import { Form } from 'formsy-semantic-ui-react'
import * as R from 'ramda'
import React from 'react'
import ThaiAddress from 'react-thai-address'
import { Button, Label } from 'semantic-ui-react'
import { generateOption } from '../../utils/index'

const countryOptions = [
  { key: 'th', value: 'Thailand', flag: 'th', text: 'ประเทศไทย' }
]

class AccountAndMailingForm extends React.Component {
  state = {
    canSubmit: false
  }

  disableButton = () => {
    this.setState({ canSubmit: false })
  }

  enableButton = () => {
    this.setState({ canSubmit: true })
  }

  render() {
    const {
      birth_day,
      email,
      gender,
      name,
      firstname,
      lastname,
      phone_number,
      handleChange,
      onClickBack,
      onClickNext,
      address_1,
      sub_district,
      district,
      province,
      country,
      postal_code,
      hideBackButton,
      submitText
    } = this.props
    const errorLabel = <Label color="red" pointing />
    return (
      <React.Fragment>
        <Form
          id="account-and-mailing"
          onValidSubmit={onClickNext}
          onValid={this.enableButton}
          onInvalid={this.disableButton}
        >
          <Form.Group widths="equal">
            <Form.Input
              disabled
              name="email"
              icon="user"
              value={email}
              iconPosition="left"
              placeholder="อีเมลล์"
              onChange={handleChange}
            />
            <Form.Input
              name="name"
              required
              icon="user"
              value={name}
              iconPosition="left"
              validationErrors={{
                isDefaultRequiredValue: 'โปรดกรอกชื่อที่แสดงบน E-Bib'
              }}
              placeholder="ชื่อที่แสดงบน E-Bib"
              onChange={handleChange}
              errorLabel={errorLabel}
            />
            <Form.Input
              validations="isLength:10"
              type="tel"
              validationErrors={{
                isDefaultRequiredValue: 'โปรดใส่เบอร์โทรศัพท์',
                isLength: 'โปรดใส่เบอร์โทรศัพท์ 10 หลัก'
              }}
              name="phone_number"
              required
              value={phone_number}
              placeholder="เบอร์โทรศัพท์"
              onChange={handleChange}
              errorLabel={errorLabel}
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Select
              required
              name="gender"
              value={gender}
              onChange={handleChange}
              options={[
                { key: 'm', text: 'ชาย', value: 'male' },
                { key: 'f', text: 'หญิง', value: 'female' }
              ]}
              placeholder="กรุณาเลือกเพศ"
            />
          </Form.Group>
          <div>
            <span>วันเกิด</span>
          </div>
          <Form.Group widths="3">
            <Form.Select
              required
              name="day"
              value={birth_day ? parseInt(birth_day.split('-')[2]) : ''}
              onChange={handleChange}
              options={generateOption(
                Array(31)
                  .fill(0)
                  .map((e, i) => i + 1)
              )}
              placeholder="วัน"
            />
            <Form.Select
              required
              name="month"
              value={birth_day ? parseInt(birth_day.split('-')[1]) : ''}
              onChange={handleChange}
              options={[
                { key: 'มกราคม', value: 1, text: 'มกราคม' },
                { key: 'กุมภาพันธ์', value: 2, text: 'กุมภาพันธ์' },
                { key: 'มีนาคม', value: 3, text: 'มีนาคม' },
                { key: 'เมษายน', value: 4, text: 'เมษายน' },
                { key: 'พฤษภาคม', value: 5, text: 'พฤษภาคม' },
                { key: 'มิถุนายน', value: 6, text: 'มิถุนายน' },
                { key: 'กรกฎาคม', value: 7, text: 'กรกฎาคม' },
                { key: 'สิงหาคม', value: 8, text: 'สิงหาคม' },
                { key: 'กันยายน', value: 9, text: 'กันยายน' },
                { key: 'ตุลาคม', value: 10, text: 'ตุลาคม' },
                { key: 'พฤศจิกายน', value: 11, text: 'พฤศจิกายน' },
                { key: 'ธันวาคม', value: 12, text: 'ธันวาคม' }
              ]}
              placeholder="เดือน"
            />
            <Form.Select
              required
              name="year"
              value={birth_day ? parseInt(birth_day.split('-')[0]) : ''}
              onChange={handleChange}
              options={generateOption(
                Array(2018 - 1920 + 1)
                  .fill()
                  .map((_, idx) => 1920 + idx)
              )}
              placeholder="ปีเกิด"
            />
          </Form.Group>
          <Form.Group widths="2" style={{ marginTop: 15 }}>
            <Form.Input
              required
              name="firstname"
              value={firstname}
              icon="user"
              iconPosition="left"
              validationErrors={{
                isDefaultRequiredValue: 'โปรดกรอกชื่อจริง'
              }}
              placeholder="กรุณาระบุชื่อจริง"
              onChange={handleChange}
              errorLabel={errorLabel}
            />
            <Form.Input
              required
              name="lastname"
              value={lastname}
              icon="user"
              iconPosition="left"
              validationErrors={{
                isDefaultRequiredValue: 'โปรดกรอกนามสกุลจริง'
              }}
              placeholder="กรุณาระบุนามสกุลจริง"
              onChange={handleChange}
              errorLabel={errorLabel}
            />
          </Form.Group>
          <Form.Group widths="equal" style={{ marginTop: 15 }}>
            <Form.Input
              required
              name="address_1"
              value={address_1}
              icon="home"
              iconPosition="left"
              validationErrors={{
                isDefaultRequiredValue: 'โปรดใส่เลขที่บ้าน ซอย เเละ ถนน'
              }}
              placeholder="กรุณาใส่เลขที่บ้าน ซอย เเละ ถนน"
              onChange={handleChange}
              errorLabel={errorLabel}
            />
          </Form.Group>
          <Form.Group widths="3">
            <Form.Select
              required
              name="province"
              value={province}
              onChange={handleChange}
              options={generateOption(ThaiAddress.provinces)}
              placeholder="จังหวัด"
            />
            <Form.Select
              required
              name="district"
              value={district}
              onChange={handleChange}
              options={generateOption(
                R.uniq(
                  R.map(R.path(['city']), ThaiAddress.search({ province }))
                )
              )}
              placeholder="อำเภอ"
            />
            <Form.Select
              required
              name="sub_district"
              value={sub_district}
              onChange={handleChange}
              options={generateOption(
                R.uniq(
                  R.map(
                    R.path(['tumbon']),
                    ThaiAddress.search({ city: district })
                  )
                )
              )}
              placeholder="ตำบล"
            />
          </Form.Group>
          <Form.Group widths="2" style={{ marginTop: 15 }}>
            <Form.Select
              required
              name="postal_code"
              value={postal_code ? parseInt(postal_code) : ''}
              onChange={handleChange}
              options={generateOption(
                R.uniq(
                  R.map(
                    R.path(['zipcode']),
                    ThaiAddress.search({ tumbon: sub_district })
                  )
                )
              )}
              placeholder="รหัสไปรษณีย์"
            />
            <Form.Select
              required
              name="country"
              value="Thailand"
              options={countryOptions}
              placeholder="ประเทศ"
              onChange={handleChange}
            />
          </Form.Group>
        </Form>
        <div style={{ marginTop: 15 }}>
          {hideBackButton ? null : (
            <Button onClick={onClickBack}>ก่อนหน้า</Button>
          )}
          <Button type="submit" form="account-and-mailing" color="teal">
            {submitText || 'ถัดไป'}
          </Button>
        </div>
      </React.Fragment>
    )
  }
}

export default AccountAndMailingForm



// WEBPACK FOOTER //
// /opt/build/repo/src/components/AccountAndMailingForm/index.js